<template>
	<van-popup v-model="show" position="left" :style="{ height: '100%' }" get-container="body" closeable    >
		<div class="aside-user" >
			<div class="m-ucenter-panel">
				<div class="m-ucenter-panel-bg"></div>
				<div class="m-cell">
					<div class="u-avatar">
						<img src="@/assets/images/head.png" alt="">
					</div>
					<div class="flex-col" v-if="$store.state.userInfo">
						<div class="u-head-title">{{$store.state.userInfo.user_name}}</div>
						<span class="vip-tag">
							<span class="iconfont icon-crown"></span><span>{{$store.state.userInfo.level_name}}</span>
						</span>
					</div>
					<span class="iconfont icon-xiaoxi" ></span>
					<span class="iconfont icon-set" @click="goUrl('/m-set')"></span>
				</div>
			</div>
			<div class="aside-navbar">
				<ul class="m-navbar-nav">
					<li v-for="(item,index) in menuData">
						<router-link class="nav-item" :to="item.url">
							{{$t(item.title)}}
						</router-link>	
					</li>
				</ul>
				<el-dropdown @command="handleCommand" v-if="langType" trigger="click">
					<div class="dropdown__trigger m__langType">
						<img :src="getFlagImage(langType)" alt="" />
						<span>{{langType}}</span>
						<i class="el-icon-arrow-down el-icon--right"></i>
					</div>
					<el-dropdown-menu slot="dropdown" class="dropdown-menu_md lan-dropdown">
						<el-dropdown-item :command="item" v-for="(item,index) in langArr" :key="`langArr${index}`">
							<div class="dropdown-menu__link">
								<span v-if="item.lang == 'us'">
									{{$t('EN')}}
								</span>
								<span class="text" v-else>
									{{$t(item.lang)}}
								</span>
							</div>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div class="m-login-out">
				<el-button type="danger" @click="loginOut">
					{{$t('退出')}}
				</el-button>
			</div>
		</div>
	</van-popup>
</template>
<script>
	import helper from '@/common/helper.js';
	import {
		user_login_out_api
	} from "@/api/user"
	export default {
		components: {},
		props: {},
		data() {
			return {
				langType: "",
				show:false,
				menuData:[
					{
						title:"我的收藏",
						url:"/Favorite"
					},
					{
						title:"我的购物车",
						url:"/Cart"
					},
					{
						title:"浏览记录",
						url:"/history"
					},
					
					{
						title:"地址管理",
						url:"/address"
					},
					{
						title:"我的订单",
						url:"/my-order"
					},
				]
			};
		},
		computed: {
			langArr() {
				let _this = this;
				let options = [];
				let selecValue = this.$helper.getLang();
				let all_lang = this.$helper.get("alllang");
				if (all_lang != null) {
					for (let i = 0; i < all_lang.length; i++) {
						options.push(all_lang[i]);
						if (selecValue == all_lang[i].lang) {
							_this.currentSelect = all_lang[i];
						}
					}
				}
				return options;
			},
		},
		methods: {
			getFlagImage(langType) {
			  return require(`@/assets/images/${langType}.png`)
			},
			handleCommand(command) {
				this.langType = command.lang;
				this.$helper.setLang(command.lang);
				this.$i18n.locale = command.lang;
				location.reload();
			},
			langChange() {
				// this.langIcon = this.$helper.get("i18n_icon");
				this.langType = this.$helper.get("i18n_lang");
			},
			async loginOut() {
				await user_login_out_api().then(res => {
					console.log(res)
					if (res && res.data.code == 1) {
						this.$helper.rm("tokenInfo");
						this.$helper.rm("userInfo");
						this.$helper.rm("CartNumber");
						this.$store.commit("$vuexSetLoginState", false);
						this.$store.commit("$vuexUserInfo", null);
						this.$message({
							customClass: "successMessage",
							showClose: false,
							message: this.$t("已成功退出当前账号"),
							center: true,
							type: "success",
							duration: "1000",
							onClose: () => {
								this.goUrl('/');
								window.location.reload();
							}
						});
					} else {
						this.errorTips("失败");
					}
				});
			},
		},
		mounted() {
			this.langChange()
			if(helper.get("userInfo") != ""){
				this.userData = helper.get("userInfo")
			}
		}
	}
</script>
<style scoped lang="scss">
	.m-login-out{
		padding: 20px;
	}
	.m-login-out .el-button{
		width: 100%;
	}
	.m__langType{
		display: flex;
		align-items: center;
		padding:0 10px;
		line-height: 1;
		img{
			width: 30px;
			height: 25px;
			margin-right: 10px;
			font-size: 18px;
		}
	}
	.aside-user{
		width: calc(100vw - 80px);
	}
	.aside-navbar{
		padding: 10px;
		background-color: #ffffff;
		border-radius: 5px;
		position: relative;z-index: 99;
		margin-left: 20px;
		margin-right: 20px;
		box-shadow: 0 0 10px rgba(0, 0, 0, .04);
	}
	
</style>